import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const token = {
  get: () => sessionStorage.getItem("atelier_token"),
  set: (t) => sessionStorage.setItem("atelier_token", t),
  clear: () => sessionStorage.removeItem("atelier_token"),
};

api.interceptors.request.use((cfg) => {
  const t = token.get();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const imgSrc = (path) =>
  !path ? "" : path.startsWith("http") ? path : `${API}/images/${path}`;

export const fmtPrice = (n) =>
  new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 0,
  }).format(n);

export const errMsg = (e, fallback = "Something went wrong — please try again") => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d))
    return d.map((x) => x?.msg).filter(Boolean).join(", ") || fallback;
  return fallback;
};

export const FALLBACK_HERO =
  "https://images.unsplash.com/photo-1541512416146-3cf58d6b27cc?crop=entropy&cs=srgb&fm=jpg&q=85";

export const availabilityLabel = (a) =>
  a === "prints" ? "Prints Available" : "Original Piece Only";

export async function prepareImage(file, maxDim = 2200) {
  try {
    if (!file.type.startsWith("image/") || file.size < 1.5 * 1024 * 1024) return file;
    const bitmap = await createImageBitmap(file, { imageOrientation: "from-image" });
    const scale = Math.min(1, maxDim / Math.max(bitmap.width, bitmap.height));
    if (scale >= 1) return file;
    const canvas = document.createElement("canvas");
    canvas.width = Math.round(bitmap.width * scale);
    canvas.height = Math.round(bitmap.height * scale);
    canvas.getContext("2d").drawImage(bitmap, 0, 0, canvas.width, canvas.height);
    const blob = await new Promise((res) => canvas.toBlob(res, "image/jpeg", 0.92));
    if (!blob) return file;
    const name = (file.name || "photo").replace(/\.[^.]+$/, "") + ".jpg";
    return new File([blob], name, { type: "image/jpeg" });
  } catch {
    return file;
  }
}

export const DEFAULT_CONTENT = {
  site_title: "ATELIER",
  hero_eyebrow: "Contemporary Fine Art Portfolio",
  hero_headline_top: "FORM &",
  hero_headline_bottom: "REVERIE",
  hero_subline:
    "A living archive of original works and limited prints — each piece catalogued, priced and waiting for the right wall.",
  marquee_items: [
    "Original Works",
    "Limited Prints",
    "Fine Art Portfolio",
    "Enquire Within",
  ],
  collection_eyebrow: "The Collection",
  collection_title: "Selected Works",
  about_eyebrow: "About the Artist",
  chapter_1_title: "Original Works",
  chapter_1_body:
    "Every original is a one-of-one object. When a piece is marked Original Piece Only, it exists as a single work and will never be reproduced.",
  chapter_2_title: "Limited Prints",
  chapter_2_body:
    "Works marked Prints Available may be owned as finely produced reproductions, while the original remains at the heart of the collection.",
  chapter_3_title: "Acquire",
  chapter_3_body:
    "Each piece carries its price. To enquire about a work, use the contact below — the studio replies personally.",
  footer_eyebrow: "Acquire",
  footer_title: "A work of your own begins with a conversation.",
};

export const mergeContent = (settings) => ({
  ...DEFAULT_CONTENT,
  ...(settings?.content || {}),
});
